import { useGetInstanceInfo } from '@postifoto/api-client';
import { useEffect } from 'react';

/**
 * Цвет бренда инстанса из настроек (ADR-039) — в CSS-переменную `--color-brand`.
 * Через CSSOM (`style.setProperty`), поэтому CSP `style-src 'self'` не мешает.
 */
export function BrandTheme() {
  const instance = useGetInstanceInfo();
  const brand = instance.data?.brand;
  useEffect(() => {
    if (!brand) return;
    document.documentElement.style.setProperty('--color-brand', brand.color);
    document.title = brand.name;
  }, [brand]);
  return null;
}
